import { Crown } from "lucide-react";
import { Panel, Field } from "@/components/admin/ui";
import { ROLE_LABELS } from "@/lib/roles";
import { PERSON_STATUS_META } from "./peopleMeta";

export const PersonOverviewTab = ({ profile }) => {
  const status = PERSON_STATUS_META[profile.current_status.status] || PERSON_STATUS_META.available;
  return (
    <Panel title="Overview" testId="person-overview-tab">
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Name" value={profile.name} testId="person-overview-name" />
        <Field label="Role" value={ROLE_LABELS[profile.role] || profile.role} testId="person-overview-role" />
        <Field label="Current Status" value={status.label} testId="person-overview-status" />
        <Field label="Upcoming Jobs" value={String(profile.upcoming_jobs_count)} testId="person-overview-upcoming-count" />
      </div>

      <div className="mt-4">
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400 dark:text-slate-500">Teams</p>
        {profile.teams.length === 0 ? (
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Not assigned to a Team.</p>
        ) : (
          <div className="mt-2 space-y-1.5" data-testid="person-overview-teams">
            {profile.teams.map((t) => (
              <div key={t.team_id} className="flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 dark:border-white/10" data-testid={`person-overview-team-${t.team_id}`}>
                <span className="text-sm font-semibold text-slate-800 dark:text-slate-200">{t.team_name}</span>
                {t.is_lead && (
                  <span className="flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-bold text-amber-600 dark:bg-amber-500/10 dark:text-amber-400">
                    <Crown size={11} /> Team Lead
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </Panel>
  );
};
